import { render, staticRenderFns } from "./SchoolsProjectComponent.vue?vue&type=template&id=307130fc"
import script from "./SchoolsProjectComponent.vue?vue&type=script&lang=js"
export * from "./SchoolsProjectComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports